const areas = [
  'Autauga County',
  'Elmore County', 
  'Montgomery County'
];

const cities = [
  'Montgomery', 'Prattville', 'Millbrook', 'Wetumpka',
  'Tallassee', 'Eclectic', 'Deatsville', 'Marbury'
];

export default function ServiceAreas() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-8">
              Serving Central Alabama<br />with Pride
            </h2>
            
            <div className="mb-8">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Our Service Counties</h3>
              <div className="space-y-3">
                {areas.map((area, index) => (
                  <div key={index} className="flex items-center space-x-3 bg-white p-4 rounded-xl shadow-sm">
                    <div className="w-10 h-10 flex items-center justify-center bg-emerald-100 rounded-full">
                      <i className="ri-map-pin-fill text-emerald-600 text-xl"></i>
                    </div>
                    <span className="text-gray-800 font-medium text-lg">{area}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-8">
              <h3 className="text-lg font-semibold text-gray-700 mb-3">Cities We Serve</h3>
              <div className="grid grid-cols-2 gap-3">
                {cities.map((city, index) => (
                  <div key={index} className="flex items-center space-x-2">
                    <i className="ri-checkbox-circle-fill text-emerald-600"></i>
                    <span className="text-gray-700">{city}</span>
                  </div>
                ))}
              </div>
            </div>

            <p className="text-gray-600 mb-6">
              Don't see your city? Contact us to inquire about service availability in your area
            </p>
            <a
              href="tel:3347826042"
              className="inline-block px-8 py-4 bg-emerald-600 text-white rounded-full font-medium hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Call (334) 782-6042
            </a>
          </div>

          <div className="relative">
            <div className="w-full h-96 rounded-3xl overflow-hidden shadow-xl">
              <img
                src="https://static.readdy.ai/image/ba6bcb6e46a4fb76c5fa17ca5b486c21/f2bcaec037718b5c2652549173aeedeb.png"
                alt="Service Area Map - Autauga, Elmore & Montgomery Counties"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}